// extracted by mini-css-extract-plugin
export default {"activityTab":"activityTabFBMfC"};